import { TimerMusicIcon } from './TimerMusicIcon';

/**
 * author: Colton Wiscombe
 * id 2BE4E342-BEAB-4B48-8CE5-E1B83D86E0D7
 * name timer-music
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-music.svg
 * tags
 * - Date / Time 
 * - Music 
 */
export const StopwatchMusicIcon = TimerMusicIcon;
export default StopwatchMusicIcon